import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {ButtonComponent} from './components/ui/button/button.component';
import {MaterialModule} from './material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ButtonNavigationComponent} from './components/ui/button-navigation/button-navigation.component';
import {StepComponent} from './components/step/step.component';
import {ButtonGroupComponent} from './components/ui/button-group/button-group.component';
import {MatGridListModule} from '@angular/material/grid-list';
import {RadioButtonBaseComponent} from './components/ui/radio-button-base/radio-button-base.component'
import {SelectInputComponent} from './components/ui/select-input/select-input.component';
import {DatepickerYearmonthComponent} from './components/ui/datepicker/datepicker-yearmonth.component'
import {RouterModule} from '@angular/router'
import {ProgressSpinnerComponent} from './components/ui/progress-spinner/progress-spinner.component';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatLegacyProgressSpinnerModule as MatProgressSpinnerModule} from '@angular/material/legacy-progress-spinner';
import {SelectComponent} from './components/ui/select/select.component';
import {
    UszkodzeniaWLokalizacjiComponent
} from './components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/lokalizacja/uszkodzenia-w-lokalizacji.component';
import {
    DaszekComponent
} from '../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/lista-rodzajow-elementow/daszek/daszek.component';
import {
    RynnyRuryComponent
} from '../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/lista-rodzajow-elementow/rynny-rury/rynnyRury.component';
import {
    SelektorLokalizacjaComponent
} from './components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/przedmiot-ubezpieczenia/lokalizacje-uszkodzen/selektor-lokalizacja/selektor-lokalizacja.component';
import {
    DachComponent
} from '../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/lista-rodzajow-elementow/dach/dach.component';
import {
    PomieszczenieComponent
} from '../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/lista-rodzajow-elementow/pomieszczenie/pomieszczenie.component';
import {
    ElewacjaComponent
} from '../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/lista-rodzajow-elementow/elewacja/elewacja.component';
import {
    SzczegolyLokalizacjiComponent
} from './components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz/szczegoly-lokalizacji/szczegoly-lokalizacji.component';
import {
    MaterialWykonczeniaComponent
} from './components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz/material-wykonczenia/material-wykonczenia.component';
import {
    WartoscComponent
} from './components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz/wartosc/wartosc.component';
import {
    RodzajPowierzchniComponent
} from './components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz/rodzaj-powierzchni/rodzaj-powierzchni.component';
import {
    SzerokoscComponent
} from './components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz/szerokosc/szerokosc.component';
import {
    WysokoscComponent
} from './components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz/wysokosc/wysokosc.component';
import {
    FormularzComponent
} from './components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz/formularz.component';
import {NumbersOnlyDirective} from './directives/numbers-only.directive';
import {
    LokalizacjeUszkodzenComponent
} from './components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/przedmiot-ubezpieczenia/lokalizacje-uszkodzen/lokalizacje-uszkodzen.component';
import {
    PomieszczeniaComponent
} from '../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/przedmiot-ubezpieczenia/lokalizacje-uszkodzen/pomieszczenia/pomieszczenia.component';
import {
    PrzedmiotySzklaneComponent
} from '../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/lista-rodzajow-elementow/przedmioty-szklane/przedmioty-szklane.component';
import {ThrottleClickDirective} from './directives/throttle-click.directive';
import {IbanDirective} from './directives/iban.directive';
import {PakExtensionsComponent} from './pak-extensions/pak-extensions.component';
import {
    GrupaUszkodzenComponent
} from './components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz/grupa-uszkodzenia/grupa-uszkodzen.component';
import {
    OgrodzeniaComponent
} from '../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/lista-rodzajow-elementow/ogrodzenia/ogrodzenia.component';
import {
    PrzedmiotUbezpieczeniaComponent
} from './components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/przedmiot-ubezpieczenia/przedmiot-ubezpieczenia.component';
import {
    ListaUszkodzenComponent
} from './components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/przedmiot-ubezpieczenia/lista-uszkodzen/lista-uszkodzen.component';
import {
    ZbiorUszkodzenModule
} from '../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/zbior-uszkodzen/zbior-uszkodzen.module';
import {
    InneComponent
} from '../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/lista-rodzajow-elementow/inny/inne.component';
import {
    KomentarzComponent
} from './components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz/komentarz/komentarz.component';
import {EkranKoncowyComponent} from './components/ekran-koncowy/ekran-koncowy.component';
import {OszkleniaWitrazeComponent} from "../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/lista-rodzajow-elementow/oszklenia-witraze/oszklenia-witraze.component";
import {
    FoliaReklamowaComponent
} from "./components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz/folia-reklamowa/folia-reklamowa.component";
import {FabWyliczPozniejComponent} from './components/proces-uszkodzen/wylicz-pozniej/fab-wylicz-pozniej.component';
import {MatButtonModule} from '@angular/material/button';
import {DodatkowePraceComponent} from "../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/lista-rodzajow-elementow/dodatkowe-prace/dodatkowe-prace.component";

@NgModule({
    declarations: [
        ButtonComponent,
        ButtonNavigationComponent,
        StepComponent,
        ButtonGroupComponent,
        RadioButtonBaseComponent,
        SelectInputComponent,
        DatepickerYearmonthComponent,
        ProgressSpinnerComponent,
        SelectComponent,
        UszkodzeniaWLokalizacjiComponent,
        RynnyRuryComponent,
        DaszekComponent,
        DachComponent,
        PomieszczenieComponent,
        OgrodzeniaComponent,
        SelektorLokalizacjaComponent,
        ElewacjaComponent,
        NumbersOnlyDirective,
        IbanDirective,
        LokalizacjeUszkodzenComponent,
        PomieszczeniaComponent,
        SzczegolyLokalizacjiComponent,
        MaterialWykonczeniaComponent,
        WartoscComponent,
        RodzajPowierzchniComponent,
        SzerokoscComponent,
        WysokoscComponent,
        FormularzComponent,
        PrzedmiotySzklaneComponent,
        ThrottleClickDirective,
        PakExtensionsComponent,
        GrupaUszkodzenComponent,
        PrzedmiotUbezpieczeniaComponent,
        ListaUszkodzenComponent,
        InneComponent,
        KomentarzComponent,
        EkranKoncowyComponent,
        OszkleniaWitrazeComponent,
        FoliaReklamowaComponent,
        FabWyliczPozniejComponent,
        DodatkowePraceComponent
    ],
    exports: [
        StepComponent,
        MaterialModule,
        ButtonNavigationComponent,
        ButtonComponent,
        ButtonGroupComponent,
        RadioButtonBaseComponent,
        SelectInputComponent,
        DatepickerYearmonthComponent,
        ProgressSpinnerComponent,
        SelectComponent,
        UszkodzeniaWLokalizacjiComponent,
        RynnyRuryComponent,
        DaszekComponent,
        DachComponent,
        PomieszczenieComponent,
        OgrodzeniaComponent,
        SelektorLokalizacjaComponent,
        ElewacjaComponent,
        NumbersOnlyDirective,
        IbanDirective,
        LokalizacjeUszkodzenComponent,
        PomieszczeniaComponent,
        SzczegolyLokalizacjiComponent,
        MaterialWykonczeniaComponent,
        WartoscComponent,
        RodzajPowierzchniComponent,
        SzerokoscComponent,
        WysokoscComponent,
        FormularzComponent,
        ThrottleClickDirective,
        PakExtensionsComponent,
        GrupaUszkodzenComponent,
        PrzedmiotUbezpieczeniaComponent,
        ListaUszkodzenComponent,
        InneComponent,
        KomentarzComponent,
        EkranKoncowyComponent,
        OszkleniaWitrazeComponent,
        FoliaReklamowaComponent,
        FabWyliczPozniejComponent,
        DodatkowePraceComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        MatGridListModule,
        RouterModule,
        MatToolbarModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        ZbiorUszkodzenModule,
        NgOptimizedImage
    ]
})

export class SharedModule {
}
